// import Vue from 'vue'
import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import { getDateGranularityConfig, getSalesComparative } from '@/app/sales_analysis/Services'

// const dateParse = (dateString) => {
//   return Number(dateString.split('-').join(''))
// }
export const NAMESPACE = 'salesAnalysis/dateGranularity/'

const _types = {
  getters: {
    WEEKLY_PERIOD_BY_WEEK: 'WEEKLY_PERIOD_BY_WEEK',
    WEEKLY_DEFAULT_PERIOD: 'WEEKLY_DEFAULT_PERIOD',
    DAILY_EXTENDED_DEFAULT_PERIOD: 'DAILY_EXTENDED_DEFAULT_PERIOD'
  },
  actions: {
    INIT: 'INIT',
    RESET: 'RESET',
    FETCH_CONFIG: 'FETCH_CONFIG',
    FETCH_SALES_COMPARATIVE: 'FETCH_SALES_COMPARATIVE',
    FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK: 'FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK',
    FETCH_DAILY_EXTENDED: 'FETCH_DAILY_EXTENDED',
    SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK: 'SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK',
    ADD_FILTER_TO_ALL_REQUEST_PARAMETERS: 'ADD_FILTER_TO_ALL_REQUEST_PARAMETERS'
  },
  mutations: {
    SET_CONFIG: 'SET_CONFIG',
    SET_REQUEST_PARAMETERS: 'SET_REQUEST_PARAMETERS',
    ADD_WEEKLY_AGGREGATION_CHART: 'ADD_WEEKLY_AGGREGATION_CHART',
    ADD_DAILY_EXTENDED_CHART: 'ADD_DAILY_EXTENDED_CHART',
    SET_WEEKLY_AGGREGATION_CHARTS: 'SET_WEEKLY_AGGREGATION_CHARTS',
    SET_DAILY_EXTENDED_CHARTS: 'SET_DAILY_EXTENDED_CHARTS',
    SET_DAILY_EXTENDED_REQUEST_PARAMETERS: 'SET_DAILY_EXTENDED_REQUEST_PARAMETERS',
    SET_FILTER: 'SET_FILTER',
    SET_TITLE: 'SET_TITLE',
    ADD_FILTER_TO_REQUEST_PARAMETERS: 'ADD_FILTER_TO_REQUEST_PARAMETERS'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const DateGranularity = {
  namespaced: true,
  state: {
    config: null,
    filter: null,
    dailyTabWeeklyAggregationCharts: [],
    dailyTabExtendedCharts: [],
    // Workaround to persist the modal title action, because the params get lost after redirect n times look at
    // dates-granularity multiple redirections in the module routes
    title: ''
  },
  getters: {
    [_types.getters.WEEKLY_PERIOD_BY_WEEK]: (state) => (week) => {
      return state.config.daily_tab.weekly_aggregation.periods.find((period) => period.week === week)
    },
    [_types.getters.WEEKLY_DEFAULT_PERIOD]: (state) => {
      const periodsLength = state.config.daily_tab.weekly_aggregation.periods.length
      return state.config.daily_tab.weekly_aggregation.periods[periodsLength - 1]
    },
    [_types.getters.DAILY_EXTENDED_DEFAULT_PERIOD]: (state) => {
      return state.config.daily_tab.daily_extended.periods[0]
    }
  },
  actions: {
    async [_types.actions.INIT] ({ dispatch, commit }) {
      const config = await dispatch(_types.actions.FETCH_CONFIG)
      commit(_types.mutations.SET_CONFIG, config)
      await dispatch(_types.actions.ADD_FILTER_TO_ALL_REQUEST_PARAMETERS)
    },
    async [_types.actions.RESET] ({ commit }) {
      commit(_types.mutations.SET_CONFIG, null)
      commit(_types.mutations.SET_WEEKLY_AGGREGATION_CHARTS, [])
    },
    async [_types.actions.FETCH_CONFIG] ({ rootState }) {
      const factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name
      const config = await getDateGranularityConfig(factTableName)
      return config
    },
    async [_types.actions.SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK] ({ commit, getters }, week) {
      // eslint-disable-next-line camelcase
      const { last_period, actual_period } = getters[_types.getters.WEEKLY_PERIOD_BY_WEEK](week)
      const lastPeriod = { startDate: last_period.start_date, endDate: last_period.end_date }
      const actualPeriod = { startDate: actual_period.start_date, endDate: actual_period.end_date }
      commit(_types.mutations.SET_REQUEST_PARAMETERS, { lastPeriod, actualPeriod })
    },
    async [_types.actions.FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK] ({ commit, dispatch, state }, week) {
      commit(_types.mutations.SET_WEEKLY_AGGREGATION_CHARTS, [])
      dispatch(_types.actions.SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK, week)
      const requestParameters = state.config.daily_tab.weekly_aggregation.request_parameters
      requestParameters.forEach(async (requestParameter) => {
        const chartOptions = await dispatch(_types.actions.FETCH_SALES_COMPARATIVE, requestParameter.parameters)
        commit(_types.mutations.ADD_WEEKLY_AGGREGATION_CHART, { options: chartOptions, name: requestParameter.name })
      })
    },
    async [_types.actions.FETCH_DAILY_EXTENDED] ({ commit, dispatch, state, getters }) {
      commit(_types.mutations.SET_DAILY_EXTENDED_CHARTS, [])
      // eslint-disable-next-line camelcase
      const { last_period: lastPeriod, actual_period: actualPeriod } = getters[_types.getters.DAILY_EXTENDED_DEFAULT_PERIOD]
      commit(_types.mutations.SET_DAILY_EXTENDED_REQUEST_PARAMETERS, { lastPeriod, actualPeriod })
      const requestParameters = state.config.daily_tab.daily_extended.request_parameters
      requestParameters.forEach(async (requestParameter) => {
        const chartOptions = await dispatch(_types.actions.FETCH_SALES_COMPARATIVE, requestParameter.parameters)
        commit(_types.mutations.ADD_DAILY_EXTENDED_CHART, { options: chartOptions, name: requestParameter.name })
      })
    },
    async [_types.actions.FETCH_SALES_COMPARATIVE] ({ commit }, payloadParameters) {
      const salesComparativeByWeek = await getSalesComparative(payloadParameters)
      return salesComparativeByWeek
    },
    async [_types.actions.ADD_FILTER_TO_ALL_REQUEST_PARAMETERS] ({ commit, state }) {
      const weeklyAggregationRequestParameters = state.config.daily_tab.weekly_aggregation.request_parameters
      commit(_types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS, weeklyAggregationRequestParameters)
      const dailyExtendedRequestParameters = state.config.daily_tab.daily_extended.request_parameters
      commit(_types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS, dailyExtendedRequestParameters)
    }
  },
  mutations: {
    [_types.mutations.SET_CONFIG] (state, config) {
      state.config = config
    },
    [_types.mutations.SET_FILTER] (state, filterObject) {
      state.filter = filterObject
    },
    [_types.mutations.SET_TITLE] (state, title) {
      state.title = title
    },
    [_types.mutations.ADD_WEEKLY_AGGREGATION_CHART] (state, { options, name }) {
      state.dailyTabWeeklyAggregationCharts.push({ options, name })
    },
    [_types.mutations.ADD_DAILY_EXTENDED_CHART] (state, { options, name }) {
      state.dailyTabExtendedCharts.push({ options, name })
    },
    [_types.mutations.SET_WEEKLY_AGGREGATION_CHARTS] (state, dailyTabWeeklyAggregationCharts) {
      state.dailyTabWeeklyAggregationCharts = dailyTabWeeklyAggregationCharts
    },
    [_types.mutations.SET_DAILY_EXTENDED_CHARTS] (state, dailyTabExtendedCharts) {
      state.dailyTabExtendedCharts = dailyTabExtendedCharts
    },
    [_types.mutations.SET_REQUEST_PARAMETERS] (state, { lastPeriod, actualPeriod }) {
      const requestParameters = state.config.daily_tab.weekly_aggregation.request_parameters
      requestParameters.forEach(requestParameter => {
        requestParameter.parameters.comparative_date_filters[0].date_from.value = [lastPeriod.startDate, lastPeriod.endDate]
        requestParameter.parameters.comparative_date_filters[1].date_from.value = [actualPeriod.startDate, actualPeriod.endDate]
      })
    },
    [_types.mutations.SET_DAILY_EXTENDED_REQUEST_PARAMETERS] (state, { lastPeriod, actualPeriod }) {
      const requestParameters = state.config.daily_tab.daily_extended.request_parameters
      requestParameters.forEach(requestParameter => {
        requestParameter.parameters.comparative_date_filters[0].date_from.value = [lastPeriod.start_date, lastPeriod.end_date]
        requestParameter.parameters.comparative_date_filters[1].date_from.value = [actualPeriod.start_date, actualPeriod.end_date]
      })
    },
    [_types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS] (state, requestParameters) {
      requestParameters.forEach(requestParameter => {
        requestParameter.parameters = { ...requestParameter.parameters, ...state.filter }
      })
    }
  }
}

export default DateGranularity



// WEBPACK FOOTER //
// ./src/app/sales_analysis/store/DateGranularity.js